<template>
   <main class="h-screen overflow-x-hidden lg:px-10 md:px-10 px-3 relative flex flex-col items-center justify-center bg-gradient-to-br from-gray-300 via-white to-gray-300">
      <transition name="right-accent">
        <img v-if="show" src="../assets/top-right.png" class="w-1/3 md:w-2/12 lg:w-2/12 absolute top-0 right-0 zIsland accent">
      </transition>
      <transition name="left-accent">
        <img v-if="show" src="../assets/bottom-left.png" class="w-1/3 md:w-2/12 lg:w-2/12 absolute bottom-0 left-0 zIsland accent">
      </transition>
      <transition name="zoom-fade">
        <img v-if="show" src="../assets/bg-pattern.png" class="h-screen absolute">
      </transition>
      <div class="flex flex-col w-full justify-center h-1/3">
      <transition name="thank-you-fade">
        <div v-if="show" class="w-full mb-10 zIsland flex justify-center flex-col items-center">
          <h1 class="font-extrabold thank-you text-gray-600">Thank you!</h1>
          <p class="text-center text-gray-500 font-bold text-tankyou lg:w-4/6 md:w-4/6 w-full px-10">Thank you for signing up to our event! Your information has been recorded and you will receive an email shortly after. While waiting for our upcoming event, you may check our awesome products <span class="text-red-400 hover:text-red-600"><a target="_blank" href="https://www.ocbcnisp.com/id/home" >here</a></span>. We can't wait to see you on April 1st!</p>
        </div>
      </transition>
        <div class="flex flex-row w-full justify-center">
          <transition name="slide-content">
            <div v-if="show" class=" flex justify-center flex-col w-96 mr-5">
              <img src="../assets/virtualIsland.png" alt="TAYTB Virtual Island"
              class="relative zIsland island mx-auto">
            </div>
          </transition>
          <transition name="slide-content">
            <div v-if="show" class="relative zIsland flex-col mt-10 items-center justify-center event-info">
                <img src="../assets/eventName.png" class="w-96 my-2"/>
            </div>
          </transition>
        </div>
      </div>
    </main>
</template>

<script>

export default {
  name: 'AfterPreSignUp',
  data () {
    return {
      show: false
    }
  },
  mounted () {
    this.show = !this.show
  }
}
</script>

<style>
 .thank-you {
   font-size: 3.4rem;
 }
 .zIsland {
    z-index: 9;
  }
  .accent {
    max-height: 25%;
  }
  .island {
    max-height: 80vh;
    width: auto;
  }
  /* island */
  .slide-fade-enter-active {
    transition: all 1s ease;
    transition-delay: .8s;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(-50px);
    opacity: 0;
  }
  .slide-fade-leave-to {
    transform: translateX(50px);
    opacity: 0;
  }
  /* content */
  .slide-content-enter-active {
    transition: all 1s ease;
    transition-delay: .8s;
  }
  .slide-content-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-content-enter, .slide-content-leave-to {
    transform: translateX(50px);
    opacity: 0;
  }
  /* background */
  .zoom-fade-enter-active {
    transition: all .8s ease;
  }
  .zoom-fade-enter {
    transform: translateY(-50px);
    opacity: 0;
  }
  .zoom-fade-leave-to {
    transform: translateY(50px);
    opacity: 0;
  }
  /* accent top right */
  .right-accent-enter, .right-accent-leave-to {
    transform: translateY(-50px);
    opacity: 0;
  }
  .right-accent-enter-active {
    transition: all .5s ease;
    transition-delay: .5s;
  }
  .right-accent-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  /* accent bottom left */
  .left-accent-enter, .left-accent-leave-to {
    transform: translateY(50px);
    opacity: 0;
  }
  .left-accent-enter-active {
    transition: all .5s ease;
    transition-delay: .3s;
  }
  .left-accent-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  /* Thank you text */
  .thank-you-fade-enter-active {
    transition: all .8s ease;
    transition-delay: .4s;
  }
  .thank-you-fade-enter {
    transform: translateY(-50px);
    opacity: 0;
  }
  .thank-you-fade-leave-to {
    transform: translateY(50px);
    opacity: 0;
  }
</style>
